<template>
    <div>
      <el-popover trigger="hover" placement="top">
          <template>
            <FieldItemArchive v-if="isShowFieldItemArchive" :key="loadTimer" :field="field" :formData="formData"/>
          </template>
          <div slot="reference" class="name-wrapper">
              <el-tag @click="showDetailAchive" type="warning" size="medium">{{ cellValue }}</el-tag>
          </div>
      </el-popover>
    </div>
</template>

<script>
import FieldItemArchive from '@/components/FieldItem/FieldItemArchive';

export default {
    components: {
        FieldItemArchive
    },
    data () {
        return {
            loadTimer: '',
            field: {},
            isShowFieldItemArchive: false
        };
    },
    props: {
        column: {
            type: Object
        },
        cellValue: {
            type: String,
            default: ''
        },
        formData: {
            type: Object
        },
        fieldsList: {
            type: Array
        }
    },
    created () {
        if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
            this.fieldsList.forEach(item => {
                if (item.id === this.column.id) {
                    this.loadTimer = new Date().getTime();
                    this.field = item;
                }
            });
        }
    },
    methods: {
        showDetailAchive () {
            this.isShowFieldItemArchive = true;
        }
    }
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicArchiveColumn.vue